// Exports
export default {
	"webNativeAppBanner": "webNativeAppBanner_zXOOy",
	"right": "right_AQj3G",
	"wrapper": "wrapper_2maBI",
	"fourButtonsLayout": "fourButtonsLayout_vCsby",
	"spot": "spot_ClimT",
	"leftSpot": "leftSpot_VaX7o",
	"qr": "qr_5aCsf",
	"phone": "phone_vpu49",
	"title": "title_JVmFK",
	"description": "description_rs5sS",
	"copy-native-app-link": "copy-native-app-link_MvYx5"
};
